// import React, { useState, useEffect } from "react";
// //import { Outlet, useLocation } from "react-router-dom";
// import axios from 'axios';
// import { Config } from '../.env.js';
// import { useLocation, useNavigate } from "react-router-dom";
// import logo from "./img/Logo (1).png";
// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fas } from '@fortawesome/free-solid-svg-icons';
// import Table from './orderPaymentAprroverTable.js'
// import MasterTable from './masterTable.js';
// import CampaignForm from "./CampaignCreateForm.js";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// // import Form from './orderForm';
// import Live from './live.js';
// // import InviteForm from '../pages/userRole';
// // import Modal from '../pages/invite';
// // import UserTable from '../pages/userTable';

// library.add(fas);
// const LeadDashboard = () => {
//     const loggedInUserName = localStorage.getItem('loggedInUserName');
//     console.log("Logged in user name:", loggedInUserName)
//     const [showCreateCampaignForm, setShowCreateCampaignForm] = useState(false);
//     const [showBrandApplications, setShowBrandApplications] = useState(false);
//     const [showInfluencerApplications, setShowInfluencerApplications] = useState(false);
//     const [menuVisible, setMenuVisible] = useState(false);
//     const [PhoneNumber, setPhoneNumber] = useState("");
//     const [WhatsappNumber, setWhatsappNumber] = useState("");
//     const [UserName, setUserName] = useState("");
//     const [Email, setemail] = useState("");
//     const [MobileNumber, setmobilenumber] = useState("");
//     const [filteredCampaigns, setFilteredCampaigns] = useState([]);
//     const [campaigns, setCampaigns] = useState([]);
//     const navigate = useNavigate();

//     const hasValNumber = /^[0-9]{1,10}$/.test(PhoneNumber || MobileNumber);
//     const hasValEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(Email);


//     const [showUserRoles, setShowUserRoles] = useState(false);



//     const [showInviteForm, setShowInviteForm] = useState(false);
//     const handleInviteTeamMembersClick = () => {
//         setShowInviteForm(true);
//         setShowUserRoles(false);
//         setShowCreateCampaignForm(false);
//         setShowInfluencerApplications(false);
//         setShowShortlistedInfluencers(false);
//     };

//     const [showAllCampaign, setShowAllCampaign] = useState(true);
//     const handleShowAllCampignClick = () => {
//         setShowAllCampaign(true);
//         setShowCreateCampaignForm(false);
//         setShowInfluencerApplications(false);
//         setShowShortlistedInfluencers(false);
//     };



//     const handleCreateNewCampaignClick = () => {
//         setShowCreateCampaignForm(true);
//         setShowBrandApplications(false);
//         setShowInfluencerApplications(false);
//         setShowShortlistedInfluencers(false);
//     };
//     const [showShortlistedInfluencers, setShowShortlistedInfluencers] = useState(false);
//     const handleShortlistedInfluencersClick = () => {
//         setShowShortlistedInfluencers(true);
//         setShowCreateCampaignForm(false);
//         setShowBrandApplications(false);
//         setShowInfluencerApplications(false);
//     };

//     const location = useLocation();
//     const brandName = location.state ? location.state.brandName : null;

//     const [selectedBrand, setSelectedBrand] = useState(null);

//     const handleBrandClick = (brand) => {
//         setSelectedBrand(brand);
//     };

//     const [isActive, setIsActive] = useState(false);

//     const toggleMenu = () => {
//         setIsActive(!isActive);
//     };

//     const handleMouseEnter = () => {
//         setIsActive(true);
//     };

//     const handleMouseLeave = () => {
//         setIsActive(false);
//     };
//     // useEffect(() => {
//     //     const fetchCampaigns = async () => {
//     //         try {
//     //             const response = await axios.get(`${Config.API_URL}/api/getcampaignbylead?leadName=${loggedInUserName}`);
//     //             const allCampaigns = response.data;

//     //             const leadCampaigns = allCampaigns.filter(campaign =>
//     //                 campaign.leads?.some(m => m.toLowerCase() === loggedInUserName?.toLowerCase())
//     //             );

//     //             setCampaigns(leadCampaigns);
//     //             setFilteredCampaigns(leadCampaigns);
//     //         } catch (error) {
//     //             console.error('Error fetching campaigns:', error);
//     //         }
//     //     };

//     //     if (loggedInUserName) {
//     //         fetchCampaigns();
//     //     }
//     // }, [loggedInUserName]);|
//     useEffect(() => {
//         const storedUserName = localStorage.getItem('loggedInUserName');
//         if (!storedUserName) return; // Don't run fetch if not available

//         const fetchCampaigns = async () => {
//             try {
//                 const response = await axios.get(`${Config.API_URL}/api/getcampaignbylead?leadName=${storedUserName}`);
//                 const allCampaigns = response.data;

//                 const leadCampaigns = allCampaigns
//                     .filter(campaign =>
//                         campaign.leads?.some(m => m.toLowerCase() === storedUserName.toLowerCase())
//                     )
//                     .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

//                 setCampaigns(leadCampaigns);
//                 setFilteredCampaigns(leadCampaigns);
//             } catch (error) {
//                 console.error('Error fetching campaigns:', error);
//             }
//         };

//         fetchCampaigns();
//     }, []);


//     // const [selectedOption, setSelectedOption] = useState('');
//     const handleLogout = () => {
//         localStorage.removeItem("userToken");
//         navigate('/signin', { replace: true });
//     };

//     return (
//         // <div className='imgfull'>
//         <nav className="navbar" role="navigation" aria-label="main navigation">
//             <div className="navbar-brand">
//                 {/* Sidebar */}
//                 <a className="navbar-item" >
//                     {/* <span className="icon mr-3">
//                         <img className="ml-5" src="./images/hobo.jpeg" alt="Menu Icon" />
//                     </span> */}
//                 </a>
//             </div>
//             <div >

//                 <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} style={{ backgroundColor: 'dark-blue' }}>
//                     <aside className={` menu  ${isActive ? '' : 'is-hidden'} overflow-hidden`}
//                         onMouseEnter={handleMouseEnter}
//                         onMouseLeave={handleMouseLeave}
//                     >
//                         <ul className="menu-list d-flex flex-row-reverse" >
//                             <div className=' has-text-left ml-5'  >
//                                 <figure className="image is-32x32" >
//                                     <img src={logo} alt="Logo" />
//                                 </figure>
//                                 <li className='my-5 has-text-white' onClick={handleCreateNewCampaignClick} style={{ whiteSpace: 'nowrap' }}>
//                                     <MenuItem title="Create New Campaign" icon="fas fa-plus" />
//                                 </li>
//                                 <li className='my-5 has-text-white' onClick={handleShortlistedInfluencersClick}>
//                                     <MenuItem title="Table for influencers" icon="fas fa-table" />
//                                 </li>


//                                 <li className='my-5 has-text-white' onClick={handleShowAllCampignClick}>
//                                     <MenuItem title=" All Campaigns" icon="fas fa-clipboard-list" />
//                                 </li>
//                                 <li className='my-5 has-text-white ' onClick={handleLogout}>
//                                     <MenuItem title="Logout" icon="fas fa-sign-out-alt" />
//                                 </li>
//                             </div>
//                         </ul>
//                     </aside>
//                 </div>

//             </div >
//             <ul className="menu1   d-flex flex-row-reverse"
//                 onMouseEnter={handleMouseEnter}
//                 onMouseLeave={handleMouseLeave}
//             >
//                 {!isActive && (
//                     <div className=' has-text-centered '>
//                         <figure className="image is-32x32" >
//                             <img src={logo} alt="Logo" />
//                         </figure>
//                         {!isActive && (
//                             <div className='my-5 has-text-white ml-4 '>
//                                 <MenuItem icon="fas fa-plus" clickHandler={handleCreateNewCampaignClick} style={{ marginLeft: "90px", marginTop: "700px" }} />
//                             </div>
//                         )}
//                         {!isActive && (
//                             <div className='my-5 has-text-white ml-4'>
//                                 <MenuItem icon="fas fa-table" clickHandler={handleShortlistedInfluencersClick} style={{ merginButton: "20vw" }} />
//                             </div>
//                         )}

//                         {!isActive && (
//                             <div className='my-5 has-text-white ml-4'>
//                                 <MenuItem icon="fas fa-clipboard-list" clickHandler={handleShortlistedInfluencersClick} style={{ merginButton: "20vw" }} />
//                             </div>

//                         )}
//                         {!isActive && (
//                             <div className='my-5 has-text-white ml-4'>
//                                 <MenuItem icon="fas fa-sign-out-alt" clickHandler={handleShortlistedInfluencersClick} style={{ merginButton: "20vw" }} />
//                             </div>
//                         )}
//                     </div>
//                 )}
//                 {!isActive && (
//                     <li className="ml-5 my-2" style={{ cursor: "pointer", }}>

//                         {/* <span className="icon is-small has-text-success">
//                             <i className="fas fa-cog" style={{ marginRight: "90px" }} ></i>
//                         </span> */}

//                     </li>
//                 )}
//             </ul>
//             {/* </div > */}
//             {/* Main content */}
//             < div className="column" >
//                 <div className="columns is-ancestor">
//                     <div className="column  mt-5">

//                         {showCreateCampaignForm ? (
//                             // Render the Create Campaign form
//                             <div className="is-child  has-text-centered" style={{ height: '100vh', width: '50vw', marginLeft: '250px' }}>
//                                 <CampaignForm />
//                             </div>
//                         ) : showShortlistedInfluencers ? (
//                             <div className='full-page-container' style={{ display: 'flex', height: '100vh', marginLeft: "150px", marginTop: "-30px" }}>
//                                 <div className='is-child' style={{ height: '150vh', width: '83vw', alignItems: 'center' }}>
//                                     <div style={{ overflowY: 'auto', flexGrow: 1 }}>
//                                         <MasterTable />
//                                     </div>
//                                 </div>
//                             </div>
//                         ) : showAllCampaign ? (

//                             <div className='subtitle' style={{ fontSize: '15px', marginLeft: "137px" }}>

//                                 {filteredCampaigns.length === 0 ? (
//                                     <p className="has-text-danger">No campaigns assigned to this lead.</p>
//                                 ) : (
//                                     <Live campaigns={filteredCampaigns} />
//                                 )}
//                             </div>
//                             // showuserRoles
//                         ) : showUserRoles ? (
//                             <div className='has-text-right ' style={{ marginLeft: "135px", marginBottom: "200px", marginTop: "-35px" }}>
//                                 <div className='field'>
//                                     <div className="control my-3 ">

//                                     </div>
//                                 </div>
//                             </div>
//                         ) : showInviteForm ? (
//                             // Display the invite form

//                             {/* mobile number */ }

//                         ) : (
//                             <div className='subtitle' style={{ fontSize: '15px', marginLeft: "90px" }}>


//                             </div>

//                         )}

//                     </div>
//                 </div>
//             </ div>

//         </nav >
//         // </div>
//     )
// }
// function MenuItem({ title, icon, clickHandler }) {
//     return (
//         <li className="ml-2 my-2" style={{ cursor: "pointer" }} onClick={clickHandler}>
//             <span className="icon is-small has-text-success mr-1">
//                 {/* {icon && <FontAwesomeIcon icon={icon} />} */}
//                 <i className={icon} style={{ marginRight: "50px" }}></i>
//             </span>
//             <span style={{ marginLeft: "-25px" }}>{title}</span>
//         </li>
//     );
// }

// export default LeadDashboard;
import React, { useState, useEffect } from "react";
//import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import { Config } from "../.env.js";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./img/Logo (1).png";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Table from "./orderPaymentAprroverTable.js";
import MasterTable from "./masterTable.js";
import CampaignForm from "./CampaignCreateForm.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import Form from './orderForm';
import Live from "./liveLead.js";
// import InviteForm from '../pages/userRole';
// import Modal from '../pages/invite';
// import UserTable from '../pages/userTable';

library.add(fas);
const LeadDashboard = () => {
    const loggedInUserName = localStorage.getItem("loggedInUserName");
    console.log("Logged in user name:", loggedInUserName);
    const [showCreateCampaignForm, setShowCreateCampaignForm] = useState(false);
    const [showBrandApplications, setShowBrandApplications] = useState(false);
    const [showInfluencerApplications, setShowInfluencerApplications] =
        useState(false);
    const [menuVisible, setMenuVisible] = useState(false);
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [WhatsappNumber, setWhatsappNumber] = useState("");
    const [UserName, setUserName] = useState("");
    const [Email, setemail] = useState("");
    const [MobileNumber, setmobilenumber] = useState("");
    const [filteredCampaigns, setFilteredCampaigns] = useState([]);
    const [campaigns, setCampaigns] = useState([]);
    const navigate = useNavigate();
    console.log("filteredCampaigns", filteredCampaigns);

    const hasValNumber = /^[0-9]{1,10}$/.test(PhoneNumber || MobileNumber);
    const hasValEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        Email
    );

    const [showUserRoles, setShowUserRoles] = useState(false);

    const [showInviteForm, setShowInviteForm] = useState(false);
    const handleInviteTeamMembersClick = () => {
        setShowInviteForm(true);
        setShowUserRoles(false);
        setShowCreateCampaignForm(false);
        setShowInfluencerApplications(false);
        setShowShortlistedInfluencers(false);
    };

    const [showAllCampaign, setShowAllCampaign] = useState(true);
    const handleShowAllCampignClick = () => {
        setShowAllCampaign(true);
        setShowCreateCampaignForm(false);
        setShowInfluencerApplications(false);
        setShowShortlistedInfluencers(false);
    };

    const handleCreateNewCampaignClick = () => {
        setShowCreateCampaignForm(true);
        setShowBrandApplications(false);
        setShowInfluencerApplications(false);
        setShowShortlistedInfluencers(false);
    };
    const [showShortlistedInfluencers, setShowShortlistedInfluencers] =
        useState(false);
    const handleShortlistedInfluencersClick = () => {
        setShowShortlistedInfluencers(true);
        setShowCreateCampaignForm(false);
        setShowBrandApplications(false);
        setShowInfluencerApplications(false);
    };

    const location = useLocation();
    const brandName = location.state ? location.state.brandName : null;

    const [selectedBrand, setSelectedBrand] = useState(null);

    const handleBrandClick = (brand) => {
        setSelectedBrand(brand);
    };

    const [isActive, setIsActive] = useState(false);

    const toggleMenu = () => {
        setIsActive(!isActive);
    };

    const handleMouseEnter = () => {
        setIsActive(true);
    };

    const handleMouseLeave = () => {
        setIsActive(false);
    };
    // useEffect(() => {
    //     const fetchCampaigns = async () => {
    //         try {
    // const response = await axios.get(`${Config.API_URL}/api/getcampaignbylead?leadName=${loggedInUserName}`);
    //             const allCampaigns = response.data;

    //             const leadCampaigns = allCampaigns.filter(campaign =>
    //                 campaign.leads?.some(m => m.toLowerCase() === loggedInUserName?.toLowerCase())
    //             );

    //             setCampaigns(leadCampaigns);
    //             setFilteredCampaigns(leadCampaigns);
    //         } catch (error) {
    //             console.error('Error fetching campaigns:', error);
    //         }
    //     };

    //     if (loggedInUserName) {
    //         fetchCampaigns();
    //     }
    // }, [loggedInUserName]);

    useEffect(() => {
        const storedUserName = localStorage.getItem("loggedInUserName");
        if (!storedUserName) return; // Don't run fetch if not available

        const fetchCampaigns = async () => {
            try {

                const response = await axios.get(
                    `${Config.API_URL}/api/getcampaignbylead?leadName=${storedUserName}`
                );
                const allCampaigns = response.data;

                const leadCampaigns = allCampaigns
                    .filter((campaign) =>
                        campaign.leads?.some(
                            (m) => m.toLowerCase() === storedUserName.toLowerCase()
                        )
                    )
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                setCampaigns(leadCampaigns);
                setFilteredCampaigns(leadCampaigns);
            } catch (error) {
                console.error("Error fetching campaigns:", error);
            }
        };

        fetchCampaigns();
    }, []);







    // const [selectedOption, setSelectedOption] = useState('');
    const handleLogout = () => {
        localStorage.removeItem("userToken");
        navigate("/signin", { replace: true });
    };

    return (
        // <div className='imgfull'>
        <nav className="navbar" role="navigation" aria-label="main navigation">
            <div className="navbar-brand">
                {/* Sidebar */}
                <a className="navbar-item">
                    {/* <span className="icon mr-3">
                        <img className="ml-5" src="./images/hobo.jpeg" alt="Menu Icon" />
                    </span> */}
                </a>
            </div>
            <div>
                <div
                    className={`navbar-menu ${isActive ? "is-active" : ""}`}
                    style={{ backgroundColor: "dark-blue" }}
                >
                    <aside
                        className={` menu  ${isActive ? "" : "is-hidden"} overflow-hidden`}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        <ul className="menu-list d-flex flex-row-reverse">
                            <div className=" has-text-left ml-5">
                                <figure className="image is-32x32">
                                    <img src={logo} alt="Logo" />
                                </figure>
                                <li
                                    className="my-5 has-text-white"
                                    onClick={handleCreateNewCampaignClick}
                                    style={{ whiteSpace: "nowrap" }}
                                >
                                    <MenuItem title="Create New Campaign" icon="fas fa-plus" />
                                </li>
                                <li
                                    className="my-5 has-text-white"
                                    onClick={handleShortlistedInfluencersClick}
                                >
                                    <MenuItem title="Table for influencers" icon="fas fa-table" />
                                </li>

                                <li
                                    className="my-5 has-text-white"
                                    onClick={handleShowAllCampignClick}
                                >
                                    <MenuItem
                                        title=" All Campaigns"
                                        icon="fas fa-clipboard-list"
                                    />
                                </li>
                                <li className="my-5 has-text-white " onClick={handleLogout}>
                                    <MenuItem title="Logout" icon="fas fa-sign-out-alt" />
                                </li>
                            </div>
                        </ul>
                    </aside>
                </div>
            </div>
            <ul
                className="menu1   d-flex flex-row-reverse"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {!isActive && (
                    <div className=" has-text-centered ">
                        <figure className="image is-32x32">
                            <img src={logo} alt="Logo" />
                        </figure>
                        {!isActive && (
                            <div className="my-5 has-text-white ml-4 ">
                                <MenuItem
                                    icon="fas fa-plus"
                                    clickHandler={handleCreateNewCampaignClick}
                                    style={{ marginLeft: "90px", marginTop: "700px" }}
                                />
                            </div>
                        )}
                        {!isActive && (
                            <div className="my-5 has-text-white ml-4">
                                <MenuItem
                                    icon="fas fa-table"
                                    clickHandler={handleShortlistedInfluencersClick}
                                    style={{ merginButton: "20vw" }}
                                />
                            </div>
                        )}

                        {!isActive && (
                            <div className="my-5 has-text-white ml-4">
                                <MenuItem
                                    icon="fas fa-clipboard-list"
                                    clickHandler={handleShortlistedInfluencersClick}
                                    style={{ merginButton: "20vw" }}
                                />
                            </div>
                        )}
                        {!isActive && (
                            <div className="my-5 has-text-white ml-4">
                                <MenuItem
                                    icon="fas fa-sign-out-alt"
                                    clickHandler={handleShortlistedInfluencersClick}
                                    style={{ merginButton: "20vw" }}
                                />
                            </div>
                        )}
                    </div>
                )}
                {!isActive && (
                    <li className="ml-5 my-2" style={{ cursor: "pointer" }}>
                        {/* <span className="icon is-small has-text-success">
                            <i className="fas fa-cog" style={{ marginRight: "90px" }} ></i>
                        </span> */}
                    </li>
                )}
            </ul>
            {/* </div > */}
            {/* Main content */}
            <div className="column">
                <div className="columns is-ancestor">
                    <div className="column  mt-5">
                        {showCreateCampaignForm ? (
                            // Render the Create Campaign form
                            <div
                                className="is-child  has-text-centered"
                                style={{ height: "100vh", width: "50vw", marginLeft: "250px" }}
                            >
                                <CampaignForm />
                            </div>
                        ) : showShortlistedInfluencers ? (
                            <div
                                className="full-page-container"
                                style={{
                                    display: "flex",
                                    height: "100vh",
                                    marginLeft: "150px",
                                    marginTop: "-30px",
                                }}
                            >
                                <div
                                    className="is-child"
                                    style={{
                                        height: "150vh",
                                        width: "83vw",
                                        alignItems: "center",
                                    }}
                                >
                                    <div style={{ overflowY: "auto", flexGrow: 1 }}>
                                        <MasterTable />
                                    </div>
                                </div>
                            </div>
                        ) : showAllCampaign ? (
                            <div
                                className="subtitle"
                                style={{ fontSize: "15px", marginLeft: "137px" }}
                            >
                                {filteredCampaigns.length === 0 ? (
                                    <p className="has-text-danger">
                                        No campaigns assigned to this lead.
                                    </p>
                                ) : (
                                    <Live campaigns={filteredCampaigns} />
                                )}
                            </div>
                        ) : // showuserRoles
                            showUserRoles ? (
                                <div
                                    className="has-text-right "
                                    style={{
                                        marginLeft: "135px",
                                        marginBottom: "200px",
                                        marginTop: "-35px",
                                    }}
                                >
                                    <div className="field">
                                        <div className="control my-3 "></div>
                                    </div>
                                </div>
                            ) : showInviteForm ? (
                                // Display the invite form

                                {
                                    /* mobile number */
                                }
                            ) : (
                                <div
                                    className="subtitle"
                                    style={{ fontSize: "15px", marginLeft: "90px" }}
                                ></div>
                            )}
                    </div>
                </div>
            </div>
        </nav>
        // </div>
    );
};
function MenuItem({ title, icon, clickHandler }) {
    return (
        <li
            className="ml-2 my-2"
            style={{ cursor: "pointer" }}
            onClick={clickHandler}
        >
            <span className="icon is-small has-text-success mr-1">
                {/* {icon && <FontAwesomeIcon icon={icon} />} */}
                <i className={icon} style={{ marginRight: "50px" }}></i>
            </span>
            <span style={{ marginLeft: "-25px" }}>{title}</span>
        </li>
    );
}

export default LeadDashboard;